import React from "react"
import ErrorPage from "@src/components/ui/ErrorPage"

const Page403: React.FC = () => {
  return (
    <ErrorPage
      code={403}
      title="Forbidden"
      description="You do not have permission to view this page. If you believe this is an error, please contact the administrator."
      primary={{ label: "Contact Support", to: "/support" }}
      secondary={{ label: "Go to Dashboard", to: "/dashboard" }}
    />
  )
}

export default Page403
